export const paymentCandidatesTranslations = {
  ru: {
    'paymentCandidates.title': 'Кандидаты распределения',
    'paymentCandidates.subtitle': 'Банковская транзакция {bankTransactionId}',
    'paymentCandidates.build': 'Построить кандидатов',
    'paymentCandidates.column.document': 'Документ',
    'paymentCandidates.column.outlet': 'Outlet',
    'paymentCandidates.column.confidence': 'Уверенность',
    'paymentCandidates.column.warnings': 'Предупреждения',
    'paymentCandidates.outletUnknown': 'Не определён',
    'paymentCandidates.action.toAllocation': 'К распределению',
    'paymentCandidates.empty.title': 'Кандидаты не построены',
    'paymentCandidates.empty.description': 'Нажмите «Построить кандидатов» после сопоставления контрагента.',
  },
  en: {
    'paymentCandidates.title': 'Allocation candidates',
    'paymentCandidates.subtitle': 'Bank transaction {bankTransactionId}',
    'paymentCandidates.build': 'Build candidates',
    'paymentCandidates.column.document': 'Document',
    'paymentCandidates.column.outlet': 'Outlet',
    'paymentCandidates.column.confidence': 'Confidence',
    'paymentCandidates.column.warnings': 'Warnings',
    'paymentCandidates.outletUnknown': 'Unresolved',
    'paymentCandidates.action.toAllocation': 'To allocation',
    'paymentCandidates.empty.title': 'Candidates not built',
    'paymentCandidates.empty.description': 'Click "Build candidates" after matching the counterparty.',
  },
  id: {
    'paymentCandidates.title': 'Kandidat alokasi',
    'paymentCandidates.subtitle': 'Transaksi bank {bankTransactionId}',
    'paymentCandidates.build': 'Buat kandidat',
    'paymentCandidates.column.document': 'Dokumen',
    'paymentCandidates.column.outlet': 'Outlet',
    'paymentCandidates.column.confidence': 'Kepercayaan',
    'paymentCandidates.column.warnings': 'Peringatan',
    'paymentCandidates.outletUnknown': 'Belum ditentukan',
    'paymentCandidates.action.toAllocation': 'Ke alokasi',
    'paymentCandidates.empty.title': 'Kandidat belum dibuat',
    'paymentCandidates.empty.description': 'Klik "Buat kandidat" setelah mencocokkan counterparty.',
  },
} as const;

export const transactionsTranslations = {
  ru: {
    'transactions.title': 'Транзакции',
    'transactions.subtitle': 'Откройте импорт выписки для просмотра транзакций',
  },
  en: {
    'transactions.title': 'Transactions',
    'transactions.subtitle': 'Open a statement import to view transactions',
  },
  id: {
    'transactions.title': 'Transaksi',
    'transactions.subtitle': 'Buka impor rekening koran untuk melihat transaksi',
  },
} as const;
